import { render, staticRenderFns } from "./pref.vue?vue&type=template&id=e419aaf2&lang=pug&"
import script from "./pref.vue?vue&type=script&lang=js&"
export * from "./pref.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e419aaf2')) {
      api.createRecord('e419aaf2', component.options)
    } else {
      api.reload('e419aaf2', component.options)
    }
    module.hot.accept("./pref.vue?vue&type=template&id=e419aaf2&lang=pug&", function () {
      api.rerender('e419aaf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/pref.vue"
export default component.exports